import React from "react";
import "./OrderTypes.css";

// ✅ MUI Icons
import RestaurantIcon from "@mui/icons-material/Restaurant";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import GridViewIcon from "@mui/icons-material/GridView";
import EmojiFoodBeverageIcon from "@mui/icons-material/EmojiFoodBeverage";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";

const orders = [
    {
        title: "Dine-In",
        status: "Included",
        type: "included",
        icon: <RestaurantIcon />,
    },
    {
        title: "Takeaway",
        status: "Included",
        type: "included",
        icon: <ShoppingBagIcon />,
    },
    {
        title: "Table Service",
        status: "Add-On",
        type: "addon",
        icon: <GridViewIcon />,
    },
    {
        title: "Catering",
        status: "Add-On",
        type: "addon",
        icon: <EmojiFoodBeverageIcon />,
    },
    {
        title: "Delivery",
        status: "Add-On",
        type: "addon",
        icon: <DeliveryDiningIcon />,
    },
];

export default function OrderTypes() {
    return (
        <div className="order-section">
            {/* HEADER */}
            <div className="order-header">
                <p className="order-subtitle">ORDER MANAGEMENT</p>
                <h2 className="order-title">
  ORDER TYPES FOR <span style={{ color: "#e66d33" }}>EVERY SCENARIO</span>
</h2>
<div className="title-underline"></div>
            </div>

            {/* CARDS */}
            <div className="order-grid">
                {orders.map((item, index) => (
                    <div className="order-card" key={index}>
                        <div className="order-icon">
                            {item.icon}
                        </div>
                        <h3 className="order-name">{item.title}</h3>
                        <span className={`order-badge ${item.type}`}>
                            {item.status}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
}